import { cx } from '@/lib/cx';

export interface LoadingProps {
  label?: string;
  /** 画面全体の中央に表示 */
  fullscreen?: boolean;
  /** パネル内の中央に表示 */
  block?: boolean;
}

/** 読み込み中表示（ソナー風の同心円） */
export function Loading({ label = '読み込み中', fullscreen, block }: LoadingProps) {
  return (
    <div className={cx('bs-loading', fullscreen && 'is-fullscreen', block && 'is-block')} role="status" aria-live="polite">
      <span className="bs-sonar" aria-hidden>
        <span />
        <span />
      </span>
      <span className="bs-loading__label">{label}</span>
    </div>
  );
}
